module.exports = __webpack_public_path__ + "../resources/img/ic-add-text.04c6026b.svg";